import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import { editDiscrepancy } from "MODULES/Receiving/actions";
import {
  form,
  Form as AppForm,
  FormInput,
  Select,
  TextArea,
  FileInput,
  FormRow
} from "MODULES/shared/components/Forms";
import { DashedSeparator } from "MODULES/shared/components";
import { toOptions, arrayToOptions } from "LIB/forms";
import { Col, Row } from "react-bootstrap";
import { QUALITY_CONTROL, REPAIR } from "MODULES/users/constants";
import { useCurrentUser } from "APP_ROOT/hooks";
import { hasAnyOfRoles } from "MODULES/users/helpers";
import {
  DISCREPANCY_TYPES,
  REASON_FOR_RESOLUTION,
  REASON_FOR_RESOLUTION_OPTIONS
} from "MODULES/Receiving/constants";
import { properCase } from "LIB/formatters/text";
import validate from "../validate";

export function Form(props) {
  const { resolved, receivingRecordType } = props;
  const currentUser = useCurrentUser();

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <Field
              name="read_only_part_number"
              component={FormInput}
              label="Part #"
              disabled
            />
          </Col>
          <Col md={6}>
            <Field
              name="read_only_serial_number"
              component={FormInput}
              label="Serial #"
              disabled
            />
          </Col>
        </FormRow>
        <DashedSeparator />
        <Row>
          <Col md={5}>
            <Field
              name="discrepancy_type"
              component={Select}
              label="Discrepancy Type"
              options={toOptions(DISCREPANCY_TYPES)}
              disabled
            />
            <Field
              name="files"
              component={FileInput}
              label="Upload Attachment(s)"
              multiple
            />
          </Col>
          <Col md={6}>
            <Field
              name="reason"
              component={TextArea}
              label="Explain the Discrepancy"
              rows={5}
            />
          </Col>
        </Row>
        {resolved && (
          <React.Fragment>
            <DashedSeparator />
            <Row>
              <Col md={5}>
                <Field
                  name={REASON_FOR_RESOLUTION}
                  component={Select}
                  label={properCase(REASON_FOR_RESOLUTION)}
                  options={arrayToOptions(REASON_FOR_RESOLUTION_OPTIONS)}
                  disabled={
                    !hasAnyOfRoles(currentUser, [QUALITY_CONTROL, REPAIR]) &&
                    receivingRecordType === "RepairOrder"
                  }
                />
              </Col>
              <Col md={6} />
            </Row>
          </React.Fragment>
        )}
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, { onSubmit: editDiscrepancy })(
  form({
    form: "editDiscrepancy",
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/Discrepancies/Edit/Form.jsx